import { render } from "./ViewTestCriteriaList.vue?vue&type=template&id=519e5f13&scoped=true"
import script from "./ViewTestCriteriaList.vue?vue&type=script&lang=js"
export * from "./ViewTestCriteriaList.vue?vue&type=script&lang=js"

import "./ViewTestCriteriaList.vue?vue&type=style&index=0&id=519e5f13&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519e5f13"]])

export default __exports__